import { render, staticRenderFns } from "./user-companies.vue?vue&type=template&id=77212c34&"
import script from "./user-companies.vue?vue&type=script&lang=js&"
export * from "./user-companies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports